import { SofiaEnvironment } from "@/sofia-environment"

interface DownloadFileOptions {
  endpoint: string
  fileName?: string
  onComplete?: () => void
  onError?: (error: Error, failedResponseStatusCode?: number) => void
}

const {
  Bff: { Url: bffHost, Credentials: credentials },
} = SofiaEnvironment

export const downloadSofiaFile = async ({ endpoint, fileName, onComplete, onError }: DownloadFileOptions) => {
  let failedResponseStatusCode: number | undefined

  try {
    const response = await fetch(`${bffHost}/${endpoint}`, {
      headers: { "X-CSRF": "1" },
      credentials,
    })

    if (!response.ok) {
      failedResponseStatusCode = response.status
      throw new Error(`Failed to fetch file: ${response.status} ${response.statusText}`)
    }

    let downloadFileName = fileName
    const blob = await response.blob()

    if (!downloadFileName) {
      const contentDisposition = response.headers.get("Content-Disposition")
      downloadFileName = contentDisposition?.match(/filename="?([^";]+)/i)?.[1]
    }

    if (!downloadFileName) {
      throw new Error("File name is missing")
    }

    const link = document.createElement("a")
    link.href = URL.createObjectURL(blob)
    link.download = downloadFileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(link.href)

    if (onComplete) {
      onComplete()
    }
  } catch (error) {
    console.error(error)
    if (onError && error instanceof Error) {
      onError(error, failedResponseStatusCode)
    }
  }
}
